module.exports = __webpack_public_path__ + "static/media/puzzle_reveal.dd834b92.ogg";